"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModalActions = exports.StyledModalContent = exports.StyledModalHeader = exports.StyledModalWrapper = exports.StyledModalOverlay = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../general");
exports.StyledModalOverlay = (0, styled_components_1.default)(general_1.Flexbox) `
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(2px);
  z-index: 9998;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  width: 100vw;
  height: 100vh;
`;
exports.StyledModalWrapper = (0, styled_components_1.default)(general_1.Paper) `
  ${({ customStyles, width }) => (0, styled_components_1.css) `
    width: ${width !== null && width !== void 0 ? width : 'auto'};
    min-height: 200px;
    height: auto;
    position: relative;
    flex-wrap: nowrap;
    overflow-y: auto;

    ${customStyles !== null && customStyles !== void 0 ? customStyles : {}}

    & .modal-close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      transition: all 0.3s ease;
      transform: rotate(0deg);
      &:hover {
        transform: rotate(180deg);
        border: 0;
      }
    }
    @media (max-width: 768px) {
      width: 100%;
      height: 100%;
    }
  `}
`;
exports.StyledModalHeader = (0, styled_components_1.default)(general_1.Flexbox) `
  width: 100%;
`;
exports.StyledModalContent = (0, styled_components_1.default)(general_1.Flexbox) `
  width: 100%;
`;
exports.StyledModalActions = (0, styled_components_1.default)(general_1.Flexbox) `
  width: 100%;
`;
//# sourceMappingURL=styles.js.map